<div class="landing">
  <div id="page-wrapper">

    <!-- Header -->
    <header id="header" class="alt">
      <h1><a href="index.html">JanguKit</a> by Vulcanalia</h1>
      <nav id="nav">
        <ul>

          <li><a href="#" class="icon fa-angle-down">Pricing</a></li>
          <li><a href="#" class="icon fa-angle-down">Features</a></li>
          <li><a href="#" class="icon fa-angle-down">Demo</a></li>

          <li><a class="button special" (click)="navigate('subscribe');" translate>home.subscribe</a></li>
          <li><a class="button" (click)="navigate('login');" translate>home.login</a></li>
        </ul>
      </nav>
    </header>

    <!-- Banner -->
    <section id="banner">
      <h2>Terms of Use</h2>
    </section>

    <section id="terms">
      <p>These general terms and conditions of use are entered into between:</p>

      <p>The manager of the website, hereinafter referred to as "the Publisher,"</p>

      <p>Any person wishing to access the site and its services, hereinafter referred to as "the User."</p>

      <p>Article 1 - Principles</p>

      <p>The purpose of these general terms and conditions of use is to provide a legal framework for the use of the JanguKit website and its services.</p>

      <p>The website JanguKit.com is a service of:</p>

      <p>Vulcanalia EURL</p>

      <p>located at 46 avenue de la république MAISONS ALFORT, France</p>

      <p>website URL: JanguKit.com</p>

      <p>The general terms and conditions of use must be accepted by all Users, and access to the site implies acceptance of these conditions.</p>

      <p>Article 2 - Evolution and Duration of the Terms</p>

      <p>These general terms and conditions of use are concluded for an indefinite period. The contract takes effect with respect to the User from the beginning of the use of the service.</p>

      <p>The JanguKit website reserves the right to modify the clauses of these general terms and conditions of use at any time and without justification.</p>

    <p>Article 3 - Access to the Site</p>

    <p>Any User with internet access can access the JanguKit website free of charge and from anywhere. The costs incurred by the User to access it (internet connection, computer equipment, etc.) are not the responsibility of the Publisher.</p>

    <p>The site and its various services may be interrupted or suspended by the Publisher, in particular during maintenance, without obligation of prior notice or justification.</p>

    <p>The User of the site has access to the following services: Online technical tests.</p>

    <p>The site includes a paid member area reserved for registered users. These users can access it using their login credentials.</p>

    <p>The services reserved for members are the following: technical skills assessment.</p>

    <p>Article 4 - Responsibilities</p>

    <p>The Publisher's liability cannot be engaged in the event of failure, breakdown, difficulty or interruption of operation, preventing access to the site or one of its features.</p>

    <p>The equipment used to connect to the site is the sole responsibility of the User, who must take all appropriate measures to protect the equipment and data, in particular from viral attacks via the Internet. The user is also solely responsible for the sites and data they consult.</p>

    <p>The Publisher cannot be held liable in the event of legal proceedings against the User:</p>

      <p>due to the use of the site or any service accessible via the Internet;</p>

      <p>due to the User's failure to comply with these general terms and conditions.</p>

      <p>The Publisher is not responsible for damages caused to the User, to third parties and/or to the User's equipment as a result of their connection to or use of the site, and the User waives any action against the Publisher as a result.</p>

      <p>If the Publisher were to be the subject of an amicable or judicial procedure as a result of the User's use of the site, it may turn against them to obtain compensation for all damages, sums, convictions and costs that may result from this procedure.</p>

      <p>Article 5 - Intellectual Property</p>

      <p>All technical documents, products, photographs, texts, logos, drawings, videos, etc., are subject to copyright and are protected by the Intellectual Property Code. When they are given to our customers, they remain the exclusive property of Vulcanalia, the sole holder of intellectual property rights on these documents, which must be returned to it upon request.</p>

      <p>Our customers undertake not to make any use of these documents that may infringe the supplier's industrial or intellectual property rights and undertake not to disclose them to any third party, except with express prior authorization given by the Publisher.</p>

      <p>Article 6 - Hypertext Links</p>

      <p>The establishment by the User of any hypertext links to all or part of the site is strictly prohibited, except with prior written authorization from the Publisher, requested by email to the following address: .</p>

      <p>The Publisher is free to refuse this authorization without having to justify its decision in any way whatsoever. In the event that the Publisher grants its authorization, it is in any case only temporary and may be withdrawn at any time, without obligation of justification on the part of the Publisher.</p>

      <p>In all cases, any link must be removed upon simple request from the Publisher.</p>

      <p>Any information accessible via a link to other sites is not under the control of the Publisher, who declines all responsibility for its content.</p>

      <p id="privacy">Article 7 - Protection of Personal Data</p>

      <p>Collected Data</p>

      <p>The personal data that is collected on this site is as follows:</p>

      <p>account opening: when creating the user's account.</p>

      <p>payment: as part of the payment for products and services offered on the website, it  does not record financial data relating to the user's bank account or credit card;</p>

      <p>communication: when the website is used to communicate with other members, data concerning user communications are temporarily stored;</p>

      <p>cookies: cookies are used as part of the use of the site. The user has the possibility to deactivate cookies from their browser settings.</p>

      <p>Use of Personal Data</p>

      <p>The personal data collected from users is intended to make available the services of the website, improve them and maintain a secure environment. More specifically, the uses are as follows:</p>

      <p>access and use of the website by the user;</p>

      <p>management of the operation and optimization of the website;</p>

      <p>organization of the conditions of use of Payment Services;</p>

      <p>verification, identification and authentication of data transmitted by the user;</p>

      <p>offering the user the possibility of communicating with other users of the website;</p>

      <p>implementation of user assistance;</p>

      <p>personalization of services by displaying advertisements based on the user's browsing history, according to their preferences;</p>

      <p>prevention and detection of fraud, malwares (malicious softwares) and management of security incidents;</p>

      <p>management of any disputes with users;</p>

      <p>sending commercial and advertising information, depending on the user's preferences.</p>

      <p>Sharing Personal Data with Third Parties</p>

      <p>Personal data may be shared with third-party companies in the following cases:</p>

      <p>when the User uses payment services, for the implementation of these services, the website is in contact with third-party banking and financial companies with which it has contracts;</p>

      <p>when the User publishes, in the free comment areas of the website, information accessible to the public;</p>

      <p>when the User authorizes a third-party website to access their data;</p>

      <p>when the website uses service providers to provide user support, advertising and payment services. These service providers have limited access to the user's data, as part of the execution of these services, and have a contractual obligation to use them in accordance with the provisions of applicable regulations regarding the protection of personal data;</p>

      <p>if required by law, the website may transmit data to respond to claims made against the website and comply with administrative and judicial procedures;</p>

      <p>if the website is involved in a merger, acquisition, asset sale or receivership, it may be required to sell or share all or part of its assets, including personal data. In this case, users would be informed before personal data is transferred to a third party.</p>

      <p>Security and Confidentiality</p>

      <p>The website implements organizational, technical, software and physical measures in terms of digital security to protect personal data against alterations, destruction and unauthorized access. However, it should be noted that the internet is not a completely secure environment and the website cannot guarantee the security of the transmission or storage of information on the internet.</p>

      <p>Implementation of User Rights</p>

      <p>In application of the regulations applicable to personal data, users have the following rights, which they can exercise by making their request to the following address: .</p>

      <p>the right of access: they can exercise their right of access to know the personal data concerning them. In this case, before the implementation of this right, the website may request proof of the user's identity in order to verify its accuracy.</p>

      <p>the right of rectification: if the personal data held by the website is inaccurate, they can request the updating of the information.</p>

      <p>the right to delete data: users can request the deletion of their personal data, in accordance with applicable data protection laws.</p>

     <p>the right to limit processing: users can ask the website to limit the processing of personal data in accordance with the assumptions provided for by the GDPR.</p>

      <p>the right to oppose the processing of data: users can oppose the processing of their data in accordance with the assumptions provided for by the GDPR.</p>

      <p>the right to portability: they can request that the website provide them with the personal data that is provided to it to transmit it to a new website.</p>

      <p>Evolution of this Clause</p>

      <p>The website reserves the right to make any changes to this clause relating to the protection of personal data at any time. If a change is made to this personal data protection clause, the website undertakes to publish the new version on its site. The website will also inform users of the modification by email, within a minimum of 15 days before the effective date. If the user does not agree with the terms of the new version of the personal data protection clause, they have the possibility of deleting their account.</p>

      <p id="cookies">Article 8 - Cookies</p>

      <p>The JanguKit website may automatically collect standard information. All information collected indirectly will only be used to track the volume, type and configuration of traffic using this site, to develop its design and layout and for other administrative and planning purposes and more generally to improve the service we offer you.</p>

      <p>Article 9 - Applicable Law</p>

      <p>These general terms and conditions of use are subject to the application of French law.</p>

      <p>If the parties fail to resolve a dispute amicably, the dispute will be submitted to the jurisdiction of the French courts.</p>
    </section>
    <!-- Footer -->

    <footer id="footer">
      <div class="footer-first">
        <div class="footer-logo">
          <img src="assets/espresso-coffee.svg" alt="" height="20px" class="coffee-icon"/>
          <p class="title-logo">JanguKit</p>
        </div>
        <div  class="footer-section">
          <p class="footer-section-title">Links</p>
          <ul>
            <li><a href="#">Features</a></li>
            <li><a href="#">Pricing</a></li>
            <li><a href="#">Documentation</a></li>
            <li><a href="#">Blog</a></li>
          </ul>
        </div>
        <div  class="footer-section">
          <p class="footer-section-title">Legal</p>
          <ul>
            <li><a href="#">Terms of Use</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Cookie Policy</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <p class="footer-section-title">Social</p>
          <ul>
            <li><a href="#">Linkedin</a></li>
            <li><a href="#">X</a></li>
          </ul>
        </div>
      </div>
      <ul class="icons">
        <li><a href="#" class="icon fa-twitter"><span class="label">Twitter</span></a></li>
        <li><a href="#" class="icon fa-facebook"><span class="label">Facebook</span></a></li>
        <li><a href="#" class="icon fa-instagram"><span class="label">Instagram</span></a></li>
        <li><a href="#" class="icon fa-github"><span class="label">Github</span></a></li>
        <li><a href="#" class="icon fa-dribbble"><span class="label">Dribbble</span></a></li>
        <li><a href="#" class="icon fa-google-plus"><span class="label">Google+</span></a></li>
      </ul>
      <ul class="copyright">
        <li>&copy; JanguKit. All rights reserved.</li>
        <li>Designed by Vulcanalia</li>
      </ul>
    </footer>

  </div>


</div>

